module.exports = __webpack_public_path__ + "static/media/logo-Pori.fc1da0d2.png";